import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';

const StyledTooltip = styled(({ className, ...props }: React.ComponentProps<typeof Tooltip>) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f0f0f0',
    color: '#333',
    maxWidth: 400,
    fontSize: 14,
    fontFamily: 'Open Sans',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
    whiteSpace: 'pre-line',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#f0f0f0',
  },
}));

const passwordCriteria = (
  <div
    style={{
      whiteSpace: 'pre-line',
      lineHeight: '22px',
      fontSize: '14px',
      fontFamily: 'Open Sans',
      padding: '8px 16px',
      borderRadius: '8px',
    }}
  >
    <strong>Password must meet all of the following requirements:</strong>
    {'\n'}• Minimum 8 characters{'\n'}• At least one lowercase letter {'\n'}• At least one uppercase
    letter {'\n'}• At least one number {'\n'}• At least one special character (e.g., !@#$%^&*){'\n'}
    • Must not contain your username
  </div>
);

export default function PasswordInfoIcon() {
  return (
    <StyledTooltip title={passwordCriteria} placement="right">
      <IconButton size="small" aria-label="Password requirements">
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </StyledTooltip>
  );
}
